module.exports = __webpack_public_path__ + "static/media/studentRepaysInvestor.8b773938.png";